export enum AuthorizationRequestFields {
  Mail = "mail",
  Password = "password",
  ClientIp = "ipClient",
}

export interface AuthorizationRequest {
  [AuthorizationRequestFields.Mail]: string;
  [AuthorizationRequestFields.Password]: string;
  [AuthorizationRequestFields.ClientIp]: string;
}

// type AuthorizationRequest = {
//   mail: string;
//   password: string;
//   ipClient: string;
// };
